import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { MissionsGetResponseBody } from "../common/type/type";
import { MissionSearchForm } from "../molecules/MissionSearchForm";
import { MissionTable } from "../molecules/MissionTable";
import { PaginationControl } from "../atoms/PaginationControl";

interface MissionViewShowProps {
  missionsList: MissionsGetResponseBody;
}

export const MissionViewShow: React.FC<MissionViewShowProps> = ({
  missionsList,
}) => {
  const navigate = useNavigate();
  const rowsPerPage = 10;

  const [page, setPage] = useState(1);
  const [filteredRows, setFilteredRows] = useState(missionsList);
  const [selectedType, setSelectedType] = useState("");
  const [selectedStartDate, setSelectedStartDate] = useState<Date | null>(null);
  const [selectedEndDate, setSelectedEndDate] = useState<Date | null>(null);

  useEffect(() => {
    setFilteredRows(missionsList);
  }, [missionsList]);

  const paginatedRows = filteredRows.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );
  const pageCount = Math.ceil(filteredRows.length / rowsPerPage);

  const normalizeDate = (date: string | Date) => {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  };

  const handleSearch = () => {
    const filtered = missionsList
      .filter((row) =>
        selectedType ? row.mission.missionType.id === selectedType : true
      )
      .filter((row) => {
        const rowStart = normalizeDate(row.mission.startedAt).getTime();
        const rowEnd = normalizeDate(row.mission.endedAt).getTime();
        const start = selectedStartDate
          ? normalizeDate(selectedStartDate).getTime()
          : null;
        const end = selectedEndDate
          ? normalizeDate(selectedEndDate).getTime()
          : null;

        if (start && end) return rowStart >= start && rowEnd <= end;
        if (start) return rowStart >= start;
        if (end) return rowEnd <= end;
        return true;
      });

    setFilteredRows(filtered);
    setPage(1);
  };

  return (
    <div>
      <MissionSearchForm
        selectedType={selectedType}
        selectedStartDate={selectedStartDate}
        selectedEndDate={selectedEndDate}
        onTypeChange={(e) => setSelectedType(e.target.value)}
        onStartDateChange={setSelectedStartDate}
        onEndDateChange={setSelectedEndDate}
        onSearch={handleSearch}
      />
      <MissionTable
        rows={paginatedRows}
        onRowClick={(id) => navigate(`/missions/${id}/detail`)}
      />
      <PaginationControl
        page={page}
        pageCount={pageCount}
        onChange={(e, newPage) => setPage(newPage)}
      />
    </div>
  );
};
